module.exports = __webpack_public_path__ + "files/74659a83f763e9d83776b5a16efa4cda.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/ubuntu-bolditalic-webfont.woff2
 ** module id = 1031
 ** module chunks = 0
 **/